import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";

import App from "./App";
import "./styles/global.css";
import "./styles/docking-theme.css";

// Vite sets BASE_URL from the `base` config (e.g. "/thread/" in production, "/" in dev).
// Strip trailing slash for BrowserRouter basename (it expects "/thread" not "/thread/").
const basename = import.meta.env.BASE_URL.replace(/\/$/, "") || "/";

// The Thread CDN can serve the SPA shell at the host root. React Router's
// basename expects the URL to already live under /thread, so move root visitors
// there before mounting the app.
const shouldRedirectHostRoot = basename !== "/" && window.location.pathname === "/";
if (shouldRedirectHostRoot) {
  window.location.replace(`${basename}/${window.location.search}${window.location.hash}`);
}

async function bootstrap() {
  // AG Grid module registration is required since v35. Thread V3 uses paid
  // row grouping/aggregation features, so register Enterprise whenever the
  // package is installed; apply the real license key when the environment has it.
  const agLicenseKey = import.meta.env.VITE_AG_GRID_LICENSE_KEY?.trim();
  try {
    const { AllEnterpriseModule, LicenseManager } = await import("ag-grid-enterprise");
    if (agLicenseKey) LicenseManager.setLicenseKey(agLicenseKey);
    ModuleRegistry.registerModules([AllCommunityModule, AllEnterpriseModule]);
  } catch {
    ModuleRegistry.registerModules([AllCommunityModule]);
  }

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <BrowserRouter basename={basename}>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
}

if (!shouldRedirectHostRoot) {
  void bootstrap();
}
